(() => {
  const C = window.JoffzProductConfigurator;
  if (!C || C.prototype.__jpcV32MountOrderProperty) return;
  C.prototype.__jpcV32MountOrderProperty = true;

  C.prototype.applyMountPurchaseGuard = function applyMountPurchaseGuardV32() {
    const material = this.getSelectedMaterial?.() || 'paper';
    const frame = this.getSelectedFrameInput?.(material)?.value || (material === 'canvas' ? 'unframed' : 'print-only');
    const mountAllowed = material === 'paper' && frame !== 'print-only';
    const mountValue = mountAllowed && this.getSelectedMount?.() === 'yes' ? 'Yes' : 'No';

    /* Mount is an order-line production preference, not a Shopify variant.
       Keep purchasing enabled and submit the choice as a line item property. */
    this.dataset.mountPreviewOnly = 'false';
    this.dataset.mountOrderProperty = mountAllowed ? mountValue.toLowerCase() : 'not-applicable';

    if (this.mountPreviewNote) this.mountPreviewNote.hidden = true;

    const propertyInput = this.querySelector('[data-jpc-mount-property]');
    if (propertyInput) {
      propertyInput.disabled = !mountAllowed;
      propertyInput.value = mountValue;
    }
  };
})();
